/**
 * Static application metadata.
 *
 * Single source of truth for support contact details and external resource
 * URLs shown on the About, Contact Support and Help Center pages.
 *
 * Version / build / release date are NOT defined here — they are injected at
 * build time from `package.json` (`version`, `build`, `release`) via Vite
 * `define` (see vite.config.ts). `package.json` is the single source of truth;
 * bump it there and these update everywhere.
 */

/** Display name of the app. */
export const APP_NAME = 'Syntry';

/** Semantic app version — injected from `package.json` `version` at build time. */
export const APP_VERSION: string = __APP_VERSION__;

/** Build / bundle number — injected from `package.json` `build` at build time. */
export const APP_BUILD: string = __APP_BUILD__;

/** Release date (YYYY-MM-DD) — injected from `package.json` `release` at build time. */
export const APP_RELEASE_DATE: string = __APP_RELEASE_DATE__;

/**
 * "What's new" changelog entries — injected from `package.json` `changelogs`
 * at build time and surfaced on the About page. Empty entries are dropped so a
 * blank placeholder never renders.
 */
export const APP_CHANGELOGS: string[] = __APP_CHANGELOGS__.filter(
  (entry) => entry.trim().length > 0,
);

/** Support inbox employees can email for help. */
export const SUPPORT_EMAIL = 'support@erpat.app';

/** Support hotline (Philippine market). */
export const SUPPORT_HOTLINE = '+63 2 8888 0000';

/** ERPat knowledge base, surfaced inside the Help Center page. */
export const KNOWLEDGE_BASE_URL = 'https://erpat.app/knowledge_base/';

/** Marketing / company site. */
export const WEBSITE_URL = 'https://erpat.app';

/** Syntry product site — the "Learn more" target of the mobile-only wall. */
export const SYNTRY_WEBSITE_URL = 'https://syntry.app';

/** Legal pages. */
export const TERMS_URL = 'https://erpat.app/terms-conditions-web/';
export const PRIVACY_URL = 'https://erpat.app/privacy-policy-web/';

/** Current Vite mode (`development` | `production` | `verify` for a local preview-server verification build). */
export const APP_ENV: string = import.meta.env.MODE;

/** Best-effort platform label derived from the user agent. */
export function detectPlatform(): string {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
  if (/Android/i.test(ua)) return 'Android';
  return 'Web';
}
